module.exports = __webpack_public_path__ + "img/Icon-proplat-resp.64a09294.svg";